import { defineComponent as _defineComponent } from 'vue'
import { Heading, Grid, CategoryCard } from '@warrenbrasil/nebraska-web';
import {
  CategoryCardMain,
  CategoryCardFooter,
  CategoryCardProfitabilityMain,
  CategoryCardProfitabilityFooter
} from './components';
import { useRoute, useRouter } from 'vue-router/composables';
import { EProductType, IProduct } from '@/modules/products/services/products';
import { WarrenSession } from '@/modules/common/services/session';
import { StorageKeys } from '@/modules/common/services/local-storage';

interface Props {
  loading: boolean;
  cards: IProduct[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsViewContent',
  props: {
    loading: { type: Boolean },
    cards: null
  },
  setup(__props: any) {


const router = useRouter();
const route = useRoute();

function hasAmount(amount: { value: number; formatted: string } | null) {
  if (!amount) return false;

  return amount.value > 0;
}

function goToCatalog(tab: EProductType) {
  WarrenSession.set(StorageKeys.ProductCatalogType, tab, true);
  router.push({ name: 'productsCatalog' });
}

function goToCategory(productType: EProductType) {
  window.location.assign(`/products/#/categories/${productType}`);
}

function handleRedirect({ productType, amount }: IProduct) {
  if (!productType) {
    const currentModule = route.name;

    router.push({ name: 'catalog', query: { module: currentModule } });
    return;
  }

  if (hasAmount(amount)) {
    goToCategory(productType);
    return;
  }

  if (productType === EProductType.Pension) {
    window.open('https://lp.warren.com.br/previdencia');
    return;
  }

  goToCatalog(productType);
}

return { __sfc: true,router, route, hasAmount, goToCatalog, goToCategory, handleRedirect, Heading, Grid, CategoryCard, CategoryCardMain, CategoryCardFooter, CategoryCardProfitabilityMain, CategoryCardProfitabilityFooter }
}

})